import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rows", "row", "template", "status"]

  connect() {
    this.nextIndex = Math.max(-1, ...this.rowTargets.map(row => Number(row.dataset.index))) + 1
  }

  add(event) {
    if (!this.hasRowsTarget || !this.hasTemplateTarget) return
    if (this.rowTargets.length >= 20) return this.announce("20項目まで追加できます。")
    // Only the trusted template is parsed as HTML; user/template copy is assigned as text values.
    this.rowsTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML.replaceAll("__INDEX__", String(this.nextIndex++)))
    const row = this.rowTargets.at(-1)
    row.querySelector('[data-field="title"]').value = event.params?.title || ""
    row.querySelector('[data-field="description"]').value = event.params?.description || ""
    row.querySelector('[data-field="title"]').focus()
    this.announce("項目を追加しました。")
  }

  remove(event) {
    if (this.rowTargets.length <= 1) return this.announce("最低1項目は残してください。")
    const row = this.rowFor(event)
    if (!row) return
    row.remove()
    this.rowTargets.at(-1)?.querySelector('[data-field="title"]').focus()
    this.announce("項目を外しました。反映するには内容を確認してください。")
  }

  up(event) {
    const row = this.rowFor(event)
    const index = this.rowTargets.indexOf(row)
    if (index <= 0 || !this.hasRowsTarget) return
    this.rowsTarget.insertBefore(row, this.rowTargets[index - 1])
    row.querySelector('[data-field="title"]').focus()
    this.announce("項目を上へ移動しました。")
  }

  down(event) {
    const row = this.rowFor(event)
    const index = this.rowTargets.indexOf(row)
    const next = this.rowTargets[index + 1]
    if (index < 0 || !next || !this.hasRowsTarget) return
    this.rowsTarget.insertBefore(next, row)
    row.querySelector('[data-field="title"]').focus()
    this.announce("項目を下へ移動しました。")
  }

  rowFor(event) {
    const row = event.currentTarget.closest('[data-preparation-editor-target~="row"]')
    return this.rowTargets.includes(row) ? row : null
  }

  announce(message) {
    if (this.hasStatusTarget) this.statusTarget.textContent = message
  }
}
